
import React from 'react';
import { Form, Input, Button, Flex } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export default ({defaultProperties = [{k: '', v: ''}], value, onChange, id}) => {

    const [properties, setProperties] = React.useState(defaultProperties);

    React.useEffect(() => {
        setProperties(defaultProperties);
    }, [defaultProperties]);

    const addProperty = () => {
        const newProperties = [...properties, {k: '', v: ''}];
        setProperties(newProperties);
        // onChange?.(newProperties);
    }

    const onPropertiesChange = (position, index, e) => {
        e = e.target.value;
        if(typeof e === 'string') e = e.trim();

        const newProperties = properties.map((item, i) => {
            if(i === index) {
                if(position === 'label') {
                    return { ...item, k: e }
                } else if(position === 'value') {
                    return { ...item, v: e }
                }
            } else {
                return item;
            }
        });
        setProperties(newProperties);
        onChange?.(newProperties);
    }

    const removeProperty = (index) => {
        const newProperties = properties.filter((item, i) => i !== index);
        setProperties(newProperties);
        onChange?.(newProperties);
    }

    return (
        <div id={id}>
            {/* <input value={value} type='hidden' /> */}
            <div>
                {
                    (properties || []).map(({k, v}, n) => {

                        return <Flex gap={10} align='center' key={n}>
                            <Form.Item>
                                <Input onChange={(e) => onPropertiesChange('label', n, e)} value={k} placeholder="时长/颜色" style={{ width: '150px'}} />
                            </Form.Item>

                            <Form.Item>
                                <Input onChange={(e) => onPropertiesChange('value', n, e)} value={v} placeholder="2小时/红色" />
                            </Form.Item>
                            <Form.Item onClick={() => removeProperty(n)}>
                                <DeleteOutlined style={{fontSize: 16}} />
                            </Form.Item>
                            {/* <a >删除</a> */}
                        </Flex>
                    })
                }
            </div>
            {properties && properties.length < 10 ? <a onClick={addProperty}>增加属性</a> : null}
        </div>
    );
}